import { useState } from 'react';
import { sb } from '../../../lib/supabase';

export function visibleItems(items, showInactive) {
  if (showInactive) return items || [];
  return (items || []).filter((it) => it.is_active !== false);
}

export function useInlineEdit(onRename, setError) {
  const [editingId, setEditingId] = useState(null);
  const [editName, setEditName] = useState('');

  function startEdit(it) {
    setEditingId(it.id);
    setEditName(it.name);
  }

  function cancelEdit() {
    setEditingId(null);
    setEditName('');
  }

  async function saveEdit(id) {
    if (!editName.trim()) {
      setError('Name is required');
      return;
    }
    await onRename(id, editName);
    cancelEdit();
  }

  return { editingId, editName, setEditName, startEdit, cancelEdit, saveEdit };
}

export async function insertLookup(orgId, table, name, extra = {}) {
  return sb.from(table).insert({ organisation_id: orgId, name: name.trim(), ...extra });
}

export async function renameLookup(table, id, name) {
  return sb.from(table).update({ name: name.trim() }).eq('id', id);
}

export async function toggleLookupActive(table, id, isCurrentlyActive) {
  return sb.from(table).update({ is_active: !isCurrentlyActive }).eq('id', id);
}

export function StatusPill({ active }) {
  return (
    <span className={`rd-pill${active ? ' active' : ' inactive'}`}>
      {active ? 'Active' : 'Inactive'}
    </span>
  );
}
